import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function RenewalThankYou() {
  const navigate = useNavigate();

  useEffect(() => {
    // Auto-redirect to member dashboard after 5 seconds
    const timer = setTimeout(() => {
      navigate('/member/dashboard');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="max-w-2xl mx-auto text-center">
      <div className="bg-white/5 rounded-lg p-8">
        <div className="text-hdlcc-lightBlue text-6xl mb-6">✓</div>
        <h1 className="text-2xl font-bold text-white mb-4">Thank You for Renewing!</h1>
        <p className="text-gray-300 mb-6">
          Your membership has been successfully renewed. A confirmation email has been sent to your
          registered email address.
        </p>
        <div className="space-y-4">
          <p className="text-gray-300">
            You will be automatically redirected to your member dashboard in 5 seconds.
          </p>
          <button
            onClick={() => navigate('/member/dashboard')}
            className="text-hdlcc-lightBlue hover:text-hdlcc-blue"
          >
            Go to Dashboard Now →
          </button>
        </div>
      </div>
    </div>
  );
}

export default RenewalThankYou;
